export const APP_BACKGROUND = '#f2e6db'
export const WHITE = '#fff'
export const BLACK = '#000'
export const FAVORITE = '#ef4444'
export const RATINGS = '#facc15'
export const DARK_BLUE = '#111827'
export const URL_COLOR = '#0000EE'
export const LIGHT_GRAY = '#9ca3af'
